import { OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

export class AbstractComponent implements OnDestroy {

  onDestroy$ = new Subject();

  constructor() {
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

}


// WEBPACK FOOTER //
// ./src/components/abstract-component.ts